import { render, staticRenderFns } from "./StaffMember.vue?vue&type=template&id=3fa868c3&"
import script from "./StaffMember.vue?vue&type=script&lang=ts&"
export * from "./StaffMember.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports